
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Check, ChevronsUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { cn } from "@/lib/utils"
import { useGym } from "@/contexts/gym-context"

export function GymSelector() {
  const { t } = useTranslation()
  const { gyms = [], selectedGym, selectGym } = useGym()
  const [open, setOpen] = useState(false)

  // Add "All Gyms" option; normalize so every option has id and name
  const gymOptions: { id: string; name: string }[] = [
    { id: "all", name: t("financialReports.allGyms") },
    ...gyms.map((g) => ({ id: g._id, name: g.name })),
  ]

  const selectedGymName = gymOptions.find((gym) => gym.id === selectedGym)?.name || t("financialReports.allGyms")

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-[200px] justify-between">
          {selectedGymName}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0">
        <Command>
          <CommandInput placeholder={t("financialReports.searchGym")} />
          <CommandList>
            <CommandEmpty>{t("financialReports.noGymFound")}</CommandEmpty>
            <CommandGroup>
              {gymOptions.map((gym) => (
                <CommandItem
                  key={gym.id}
                  value={gym.id}
                  onSelect={(currentValue) => {
                    selectGym(currentValue)
                    setOpen(false)
                  }}
                >
                  <Check className={cn("mr-2 h-4 w-4", selectedGym === gym.id ? "opacity-100" : "opacity-0")} />
                  {gym.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
